window.HAS_CART = true
window.selectedVariant

let mulberrySelectors = {
  cartItem: '.cart-item',
  cartItemTitle: '.cart-item__details',
  cartAppendElement: '.cart-item__details',
  pdpForm: "button[name='add']",
  elementToAppendTo: '.product-form',
  clickOrSubmit: 'click',
}

function getCurrentlySelectedVariant(variants, name) {
  let selectedVariant
  if (!name) {
  	selectedVariant = variants.find(i => i.id == mulberryShop.selectedVariantId)
  } else {
  	selectedVariant = variants.find(i => i.title == (name.toString()))
  }  
  
  return selectedVariant
}

function setupCustomVariantChange() {
  if (document.querySelector(".variant-radios-options")) {
    document.querySelector(".variant-radios-options").addEventListener('change', function(e) {
        productInfo = {productName: e.target.value} // this will suppress an adapter error
        variantChangeEvent = new CustomEvent("mulberry-shopify:variant-change", {detail: productInfo})
        document.dispatchEvent(variantChangeEvent)
  	})
  }
}

function refreshCart(content) {
  price = content.items_subtotal_price
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: content.currency,
    minimumFractionDigits: 2 
  });
  total = formatter.format(price / 100, 0)
  $(".totals__subtotal-value").text(total + " USD")
}

function updateCartWidgetInfo() {
  $("warranty-details").each(function(idx, item){$(item).remove()})
  
  document.querySelectorAll(mulberrySelectors.cartItem).forEach(function(item){
    variantId = $(item).find(".cart-item__details").find("a").attr("href").split("variant=")[1]
    
    item.setAttribute('data-mulberry-variant-id', variantId)
    
    if($(item).find(mulberrySelectors.cartItemTitle).text().includes('Mulberry Protection')) {
      item.setAttribute('style', 'display: none;')
    }
    else {
      item.setAttribute('style', '')
    }
    var div = $(`<div style="max-width: 250px"/>`)
    var $newWarrantyDetails = $(`<warranty-details/>`).attr('data-variant-id', variantId)
    var add = div.append($newWarrantyDetails)    
    $(item).find(mulberrySelectors.cartAppendElement).append(add)
  })
}


async function setCartInfoAndRender(content, init=true) {
  refreshCart(content)
  updateCartWidgetInfo()
  if(window.HAS_CART) {
    if(init){
      await mulberryShop.cart.init()
    }
    mulberryShop.cart.render()
  }
}

async function mulberryPdpInit() {

  HAS_MODAL = mulberry.core.settings.has_modal
  HAS_INLINE = mulberry.core.settings.has_inline

  if(window.location.pathname.indexOf("/products/") === -1) {
    return
  }

  if(!HAS_MODAL && !HAS_INLINE) {
    return
  }

  setupCustomVariantChange()
  
  if(HAS_INLINE) {
    let divContainer = document.createElement('div')
    let mulberryDiv = document.createElement('div')
    divContainer.setAttribute('style', 'display:flex; flex-direction: column; width: 380px;')
    mulberryDiv.classList.add('mulberry-inline-container')
    mulberryDiv.setAttribute('style', 'width: 100%;')
    divContainer.append(mulberryDiv)
    document.querySelector(mulberrySelectors.elementToAppendTo).insertAdjacentElement('afterbegin', divContainer)
  }

  let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
  let product = response.product;
  let selectedVariant = getCurrentlySelectedVariant(product.variants, null)
  window.selectedVariant = selectedVariant
  const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
  })
  
  if (offers.length === 0) {
  	return
  }


  const { settings } = mulberry.core;
  let selectedOffer;
  if(HAS_INLINE){
    window.pdpInline = await mulberry.inline.init({
        offers: offers, 
        settings: mulberry.core.settings,
        selector: '.mulberry-inline-container',
        onWarrantyToggle: async (warranty) => {
          mulberry.inline.isSelected = warranty.isSelected
          if(warranty.isSelected) {
            selectedOffer = warranty.offer
          }
          else {
            selectedOffer = null
          }
        }
      })
  }
  
//   if(HAS_MODAL){
//     window.pdpModal = await mulberry.modal.init({
//         offers: offers, 
//         settings: mulberry.core.settings,
//         onWarrantySelect: async (warranty) => {
//           const result = await mulberryShop.getWarrantyVariant(warranty);

//           await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: response.product.title, variantId: window.selectedVariant.id}, warranty);
//           mulberry.modal.close();
//           removeAndSyncWarranties()
//         },
//         onWarrantyDecline: async () => {
//           mulberry.modal.close();
//           removeAndSyncWarranties()
//         }
//       })
//   }


  document.addEventListener('mulberry-shopify:variant-change', async function(e) {
    window.pdpInline.deselectOffer()
    let selectedOffer = null
  	let selectedVariant =  getCurrentlySelectedVariant(product.variants, e.detail.productName)
    window.selectedVariant = selectedVariant

    const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
    })

    if(HAS_INLINE){
      window.pdpInline.updateOffer(offers);
    }
//     if(HAS_MODAL) {
//       window.pdpModal.updateOffer(offers)
//     }

  });

  $pdpForm = $(mulberrySelectors.pdpForm)
  $pdpForm.on(mulberrySelectors.clickOrSubmit, async function(e){
    if(HAS_INLINE && selectedOffer) {
      window.pdpInline.deselectOffer()
      setTimeout(async function(){
       const result = await mulberryShop.getWarrantyVariant(selectedOffer);
       await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: response.product.title, variantId: window.selectedVariant.id}, selectedOffer);
       removeAndSyncWarranties()
       selectedOffer = null
      }, 250)
      $pdpForm.submit()
      return
    }

//     else if(HAS_MODAL) {
//       window.pdpModal.open()
//       return
//     }

    if(selectedOffer) {
      setTimeout(async function(){
       window.pdpInline.deselectOffer()
       const result = await mulberryShop.getWarrantyVariant(selectedOffer);
       await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: response.product.title, variantId: window.selectedVariant.id}, selectedOffer);
       removeAndSyncWarranties()
       selectedOffer = null
      }, 250)  
    }
//     else {
//       window.pdpModal.open()
//     }
  })
}



async function removeAndSyncWarranties(reload=false) {
  await fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      cart.json().then(function (firstCart) {
        mulberryShop.removeDetachedWarranty(firstCart)// Remove Warranties First 
        .then(newCart => {
          mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second 
          .then(content => {
            if (content.item_count === 0) {
            	let midPage = document.querySelector('cart-items')
                let footer = document.querySelector('#main-cart-footer')
                
                midPage.classList.add("is-empty")
                footer.classList.add("is-empty")
            }
               
            setCartInfoAndRender(content)
            
            let cartBubble = document.querySelector('.cart-count-bubble')
            let bubbleChild = cartBubble.children[0]
            bubbleChild.innerText = content.item_count
            
            let cartButton = document.querySelector('#cart-notification-button')
            cartButton.innerHTML = (`View my cart (${content.item_count})`)
          })
        })
      });
    })
}


function setupFetchListeners() {
    const {fetch: origFetch} = window;
    window.fetch = async (...args) => {
      const response = await origFetch(...args);
      let requestUrl = args[0]
      if(requestUrl.includes('cart/add') ||  requestUrl.includes('cart.php') || requestUrl.includes('cart/change') || requestUrl.includes('cart/update')) {
          response
            .clone()
            .json()
            .then(body => {  
                if(requestUrl.includes('cart/add')) {
                    fetchAddCustomEvent = new CustomEvent("fetch:cart-add")
                    document.dispatchEvent(fetchAddCustomEvent)
                }
                
                else if(requestUrl.includes('cart/change')) {
                    fetchChangeCustomEvent = new CustomEvent("fetch:cart-change")
                    document.dispatchEvent(fetchChangeCustomEvent)
                }

                else if(requestUrl.includes('cart/update')) {
                    fetchUpdateCustomEvent = new CustomEvent("fetch:cart-update")
                    document.dispatchEvent(fetchUpdateCustomEvent)
                }
                else {
                    if(requestUrl.includes('cart.php')) {
                        fetchCartCustomEvent = new CustomEvent("fetch:cart-page")
                        document.dispatchEvent(fetchCartCustomEvent)
                    }
                }
            }).catch(err => console.error(err));
      }
      return response
    };
}


document.addEventListener('mulberry-shopify:loaded', function() {
   if (window.location.href.includes('/products/')) {
     mulberryPdpInit()
   }
  
  if (window.location.href.includes('/cart')) {
  	removeAndSyncWarranties()
    setupFetchListeners()
    addCartEventListeners()
  }
})


function addCartEventListeners() {
  document.addEventListener('fetch:cart-change', async function() {
  	await removeAndSyncWarranties()
  })
  
  document.addEventListener('mulberry-shopify:warranty-added', async function() {
  	await removeAndSyncWarranties()
  })
} 
